import { Link } from "@inertiajs/react";
import { Button } from "@/components/ui/Button";

export function FlashNotice({
  message,
  link,
  linkLabel,
  onDismiss,
}: {
  message: string;
  link?: string;
  linkLabel?: string;
  onDismiss: () => void;
}) {
  return (
    // pointerEvents: Radix modals set pointer-events:none on <body>; the toast is
    // portaled there, so restore clickability for its own content (e.g. the link).
    <div style={{ position: "fixed", top: 16, left: "50%", transform: "translateX(-50%)", zIndex: 10000, maxWidth: 420, width: "100%", pointerEvents: "auto" }}>
      <div style={{
        display: "flex", alignItems: "center", gap: 10,
        padding: "10px 14px", borderRadius: 8, fontSize: 13,
        background: "var(--success-surface)",
        border: "1px solid var(--success-surface)",
        color: "var(--success)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      }}>
        <span style={{ fontSize: 16, flexShrink: 0 }}>{"✓"}</span>
        <span style={{ flex: 1 }}>
          {message}
          {link && (
            <Link href={link} style={{ marginLeft: 6, textDecoration: "underline", color: "inherit" }}>
              {linkLabel ?? "View"}
            </Link>
          )}
        </span>
        <Button
          variant="ghost"
          size="icon"
          onClick={onDismiss}
          className="h-auto w-auto p-0 px-0.5 text-base text-current hover:bg-transparent flex-shrink-0"
        >
          &times;
        </Button>
      </div>
    </div>
  );
}
